import { render, staticRenderFns } from "./ChangeViaCall.vue?vue&type=template&id=5e06f26d&"
import script from "./ChangeViaCall.vue?vue&type=script&lang=js&"
export * from "./ChangeViaCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports